import { render, staticRenderFns } from "./GLTFPointKeymap.vue?vue&type=template&id=842bc5b4"
import script from "./GLTFPointKeymap.vue?vue&type=script&lang=ts"
export * from "./GLTFPointKeymap.vue?vue&type=script&lang=ts"
import style0 from "./GLTFPointKeymap.vue?vue&type=style&index=0&id=842bc5b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VCheckbox,VList,VListItem})
